import { ssylkiProektov, zagolovokProektov, type ChastFrazy, type Sajt } from '@/lib/nashi-proekty';

/**
 * Блок «Наши проекты» в подвале aisearch.tech, ingdg.com и datahunter.store
 * (`lib/nashi-proekty.ts`). Без хуков: язык и сайт приходят из подвала,
 * и ссылки попадают в готовый HTML, а не появляются после загрузки JS.
 *
 * Обычный `<a>`, а не Link: адреса на других доменах.
 */
export function NashiProekty({ sajt, locale }: { sajt: Sajt; locale: string }) {
  return (
    <nav aria-label={zagolovokProektov(locale)} className="mt-10">
      <p className="font-semibold text-sm mb-4">{zagolovokProektov(locale)}</p>
      <ul className="flex flex-wrap gap-x-10 gap-y-3">
        {ssylkiProektov(sajt, locale).map((p) => (
          <li key={p.href} className="text-sm">
            <a
              href={p.href}
              className="font-medium text-[var(--color-text)] hover:text-[var(--color-accent-400)] transition-colors"
            >
              {p.nazvanie}
            </a>
            <span className="text-[var(--color-text-muted)]"> — {p.podpis}</span>
          </li>
        ))}
      </ul>
    </nav>
  );
}

/**
 * Фраза со ссылкой на соседний продукт внутри текста страницы
 * (`frazaSeoIngdg` и соседи в `lib/nashi-proekty.ts`).
 */
export function FrazaSoSsylkoj({
  chasti,
  className,
}: {
  chasti: ChastFrazy[];
  className?: string;
}) {
  return (
    <p className={className}>
      {chasti.map((c, i) =>
        typeof c === 'string' ? (
          c
        ) : (
          <a
            key={i}
            href={c.href}
            className="underline hover:text-[var(--color-accent-400)] transition-colors"
          >
            {c.tekst}
          </a>
        ),
      )}
    </p>
  );
}
